import React from 'react'
import { Chip } from 'lune-ui-lib'
import { SxProps } from '@mui/material'
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined'

const ForAPI = ({ sx }: { sx?: SxProps }) => {
    return (
        <Chip sx={{ ...sx, maxWidth: 'max-content' }} label={'API'} icon={<CodeOutlinedIcon />} />
    )
}

export default ForAPI
